//1. 发送请求的时候，如果有token，需要附带到请求头中
//2. 响应的时候，如果有token，保存token到本地（localstorage）
//3. 响应的时候，如果响应的消息码是403（没有token，token失效），在本地删除token
import axios from "axios";
import {Message} from 'element-ui';
import router from '../router'
// baseURL:'https://yinshitech.cn:9217/api',
// const debug = process.env.NODE_ENV !== 'production'
var instance = axios.create({
    // baseURL: 'http://cashcowerp.com:9217',  //测试
    // baseURL: 'http://192.168.0.107:9217',    //刘志杰
    baseURL:  'https://yinshitech.cn/api',  //正式
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    }
})
export default (function () {
    //1.发送请求的时间，如果有token,需要附带到请求头
    const token = localStorage.getItem("token");
    if (token) {
        instance = axios.create({
            // baseURL: 'http://cashcowerp.com:9217',  //测试
            // baseURL: 'http://192.168.0.107:9217',    //刘志杰
            baseURL:  'https://yinshitech.cn/api',  //正式
            headers:{
                authorization:"Bearer " + token,
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
            },
        });
    }
    instance.interceptors.response.use(
        (resp)=>{
        //     //2. 响应的时候，如果有token，保存token到本地（localstorage）
            // if(resp.data.data){
            //     localStorage.setItem("token",resp.data.data);
            // }
            return resp;
        },
        (err)=>{
            //3. 响应的时候，如果响应的消息码是403（没有token，token失效），在本地删除token
            console.log(123)
            if(err.response == undefined || err.response.status === 403){
                localStorage.removeItem("token");
                Message({ showClose: true, message: '您没用权限访问！', type: 'error' });
                router.push('/login')
            }
            if(err.response.status === 500){
                localStorage.removeItem("token");
                Message({ showClose: true,message: 'token过期，请从新登入！', type: 'error'});
                router.push('/login')
            }
            return Promise.reject(err);
        }
    );
    return instance;
})